import { useState } from 'react'
import Segmented from './Segmented.jsx'

// Record-page layout. Desktop: three columns. ≤1100px: right tucks under
// center. ≤640px: Segmented tabs pick one visible region (CSS hides the rest;
// all regions stay mounted so state survives tab switches).
// `tabbed` forces the tab layout at every width — for a record shown in a
// narrow side panel, where three columns can't fit whatever the viewport.
export default function StackColumns({ left, center, right, labels = ['Overview', 'Activity', 'Related'], tabbed = false }) {
  const [tab, setTab] = useState(0)
  const options = labels.map((label, i) => ({ key: String(i), label }))
  return (
    <div className={tabbed ? 'cn-stack cn-stack--tabbed' : 'cn-stack'}>
      <div className="cn-stack-tabs">
        <Segmented size="sm" value={String(tab)} onChange={(k) => setTab(Number(k))} options={options} />
      </div>
      <div className="cn-stack-left cn-stack-region" data-active={tab === 0 ? 'true' : 'false'}>{left}</div>
      <div className="cn-stack-center cn-stack-region" data-active={tab === 1 ? 'true' : 'false'}>{center}</div>
      <div className="cn-stack-right cn-stack-region" data-active={tab === 2 ? 'true' : 'false'}>{right}</div>
    </div>
  )
}
